module.exports = __webpack_public_path__ + "images/marketing/hero4.jpg";